import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
import { Button, ButtonVariant } from '../Button';
export var DataListToggle = function DataListToggle(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isExpanded = _a.isExpanded,
      isExpanded = _a$isExpanded === void 0 ? false : _a$isExpanded,
      _a$ariaControls = _a['aria-controls'],
      ariaControls = _a$ariaControls === void 0 ? '' : _a$ariaControls,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Details' : _a$ariaLabel,
      _a$rowid = _a.rowid,
      rowid = _a$rowid === void 0 ? '' : _a$rowid,
      id = _a.id,
      props = __rest(_a, ["className", "isExpanded", 'aria-controls', 'aria-label', "rowid", "id"]);

  return React.createElement("div", Object.assign({
    className: css(styles.dataListItemControl, className)
  }, props), React.createElement("div", {
    className: css(styles.dataListToggle)
  }, React.createElement(Button, {
    id: id,
    variant: ButtonVariant.plain,
    "aria-controls": ariaControls !== '' && ariaControls,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabel !== 'Details' ? null : "".concat(rowid, " ").concat(id),
    "aria-expanded": isExpanded
  }, React.createElement("div", {
    className: css(styles.dataListToggleIcon)
  }, React.createElement(AngleRightIcon, null)))));
};